import request from './request'
import { API_PATHS } from './config'

// 获取店铺产品列表
export function getShopList(data) {
    return request({
        url: API_PATHS.GetShopItem,
        method: 'post',
        data
    })
}

// 获取店铺信息
export function getShopInfo(data) {
    return request({
        url: API_PATHS.GetShopInfo,
        method: 'post',
        data
    })
}


// 获取爆款推荐
export function getShopRec(data) {
    return request({
        url: API_PATHS.ProductList,
        method: 'post',
        data
    })
}

//获取标签
export function getTags() {
    return request({
        url: API_PATHS.GetTags,
        method: 'get',
    })
}


// WEBPACK FOOTER //
// ./src/util/cps/models.js